import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Emitter } from '../common/event.js';

var WindowManager = /*#__PURE__*/function () {
  function WindowManager() {
    _classCallCheck(this, WindowManager);

    // --- Zoom Level
    this._zoomLevel = 0;
    this._lastZoomLevelChangeTime = 0;
    this._onDidChangeZoomLevel = new Emitter();
    this.onDidChangeZoomLevel = this._onDidChangeZoomLevel.event; // --- Zoom Factor

    this._zoomFactor = 1;
  }

  _createClass(WindowManager, [{
    key: "getZoomLevel",
    value: function getZoomLevel() {
      return this._zoomLevel;
    }
  }, {
    key: "getTimeSinceLastZoomLevelChanged",
    value: function getTimeSinceLastZoomLevelChanged() {
      return Date.now() - this._lastZoomLevelChangeTime;
    }
  }, {
    key: "getZoomFactor",
    value: function getZoomFactor() {
      return this._zoomFactor;
    } // --- Pixel Ratio

  }, {
    key: "getPixelRatio",
    value: function getPixelRatio() {
      var ctx = document.createElement('canvas').getContext('2d');
      var dpr = window.devicePixelRatio || 1;
      var bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
      return dpr / bsr;
    }
  }]);

  return WindowManager;
}();

WindowManager.INSTANCE = new WindowManager();
export function getZoomLevel() {
  return WindowManager.INSTANCE.getZoomLevel();
}
/** Returns the time (in ms) since the zoom level was changed */

export function getTimeSinceLastZoomLevelChanged() {
  return WindowManager.INSTANCE.getTimeSinceLastZoomLevelChanged();
}
export function onDidChangeZoomLevel(callback) {
  return WindowManager.INSTANCE.onDidChangeZoomLevel(callback);
}
/** The zoom scale for an index, e.g. 1, 1.2, 1.4 */

export function getZoomFactor() {
  return WindowManager.INSTANCE.getZoomFactor();
}
export function getPixelRatio() {
  return WindowManager.INSTANCE.getPixelRatio();
}
var userAgent = navigator.userAgent;
export var isEdge = userAgent.indexOf('Edge/') >= 0;
export var isFirefox = userAgent.indexOf('Firefox') >= 0;
export var isWebKit = userAgent.indexOf('AppleWebKit') >= 0;
export var isChrome = userAgent.indexOf('Chrome') >= 0;
export var isSafari = !isChrome && userAgent.indexOf('Safari') >= 0;
export var isWebkitWebView = !isChrome && !isSafari && isWebKit;
export var isIPad = userAgent.indexOf('iPad') >= 0 || isSafari && navigator.maxTouchPoints > 0;
export var isEdgeWebView = isEdge && userAgent.indexOf('WebView/') >= 0;
export var isStandalone = window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;